import React from 'react';
import {  Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteLocationModal = ({isOpen, onConfirm, onCancel, locationName}) => {
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>{`Delete ${locationName}?`}</ModalHeader>
        <ModalBody>{`Do you really want to delete the location '${locationName}'?`}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onConfirm}>Yes</Button>
          {' '}
          <Button color="secondary" onClick={onCancel}>No</Button>
        </ModalFooter>
      </Modal>
    )
};

export default DeleteLocationModal;
